/**
 * (양력 year, month) → 월주(月柱) 한자 2글자 산출.
 *
 * 절기 정확도 대신 양력 월 기준 근사 매핑을 사용한다 (낭만월운 UI 가 양력 월 단위
 * 카드라 매월 1일 이후 동일 月柱가 유지되어야 한다는 제품 정의를 따른다):
 *   - 양력 2월 → 寅月, 3월 → 卯月, ..., 12월 → 子月, 1월 → 丑月
 *   - 1월은 입춘 전이므로 사주 연도는 (year - 1) 로 간주한다.
 *
 * 月干은 五虎遁 규칙으로 결정한다:
 *   甲己年 → 丙寅 / 乙庚年 → 戊寅 / 丙辛年 → 庚寅 / 丁壬年 → 壬寅 / 戊癸年 → 甲寅
 *   = 寅月 干 idx = ((yearStemIdx % 5) + 1) * 2 % 10
 *
 * @param {number} year 양력 연도
 * @param {number} month 양력 월 (1~12)
 * @returns {string} 月柱 한자 (예: '癸巳'). year/month 가 유효하지 않으면 '' 반환.
 */
const SKY = '甲乙丙丁戊己庚辛壬癸';
const EARTH = '子丑寅卯辰巳午未申酉戌亥';

export const getMonthGanjiByYearMonth = (year, month) => {
  if (!year || !month || month < 1 || month > 12) return '';
  // 양력 1월은 입춘(2월 초) 전이라 사주 연도는 전년도
  const sajuYear = month === 1 ? year - 1 : year;
  const yearStemIdx = ((sajuYear - 4) % 10 + 10) % 10;
  const tigerStemIdx = (((yearStemIdx % 5) + 1) * 2) % 10; // 寅月 干 idx
  // 양력 월 → 寅月 기준 오프셋 (Feb=0, Mar=1, ..., Dec=10, Jan=11)
  const monthOffset = (month - 2 + 12) % 12;
  const stemIdx = (tigerStemIdx + monthOffset) % 10;
  const branchIdx = (2 + monthOffset) % 12; // 寅=2
  return `${SKY[stemIdx]}${EARTH[branchIdx]}`;
};
